import * as React from "react";
import { useContext } from "react";
import { EditProjectContext } from "../../../EditProjectContext";
import { updateRoutePropertyOnProject } from "./UpdateRoutePropertyOnProject";
import { isProjectReadOnly } from "../../../IsProjectReadOnly";
import { DropDownList } from "../../../../../Layout/Inputs/DropDownList";
import { RouteNumberAreaInputProps } from "./RouteNumberAreaInputProps";

export const ControlType = ({ route, disabled = false }: RouteNumberAreaInputProps) => {
  const projectContextProps = useContext(EditProjectContext);
  const { project } = projectContextProps;

  const list = [
    { text: "DCI Controlled", value: "DCI Controlled" },
    { text: "Levelling & Rounding", value: "Levelling & Rounding" },
    { text: "Time Window Only", value: "Time Window Only" },
    { text: "CTI Controlled", value: "CTI Controlled" },
    { text: "Pull Ahead", value: "Pull Ahead" },
  ];

  return (
    <DropDownList
      label="Control Type"
      list={list}
      value={route.ControlType}
      onChange={(value) => {
        updateRoutePropertyOnProject(
          "ControlType",
          value,
          route.RouteNumber || "",
          projectContextProps
        );
      }}
      disabled={isProjectReadOnly(project) || disabled}
    />
  );
};
